import Drawer from '@material-ui/core/Drawer';
import React, {useState} from 'react';

import {useHandleScroll} from '../../../../../pages/HomePage/HomePageSidebar/useHandleScroll';
import {CollectionInfo} from '../../../../ModelRegistry/utils';
import {ResizableDrawer} from '../../ResizableDrawer';
import {Artifact} from '../CreateRegisteredCollectionDrawerInner';
import * as S from '../CreateRegisteredCollectionDrawerInner.styles';
import {LinkArtifactDrawerInner} from './LinkArtifactDrawerInner';

/**
 * The hierarchy of components here is:
 * LinkArtifactDrawer - thin wrapper to allow animated drawer transition without loading content
 * LinkArtifactDrawerInner - queries for data, shows loading indicator
 */

type LinkArtifactDrawerProps = {
  open: boolean;
  closeDrawer: () => void;

  defaultProjectName: string;
  artifactTypeName: string;
  artifact: Artifact;
  afterLink: (collection: CollectionInfo) => void;
};

export const LinkArtifactDrawer = ({
  open,
  closeDrawer,
  defaultProjectName,
  artifactTypeName,
  artifact,
  afterLink,
}: LinkArtifactDrawerProps) => {
  const [width, setWidth] = useState(600); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };
  const scrolled = useHandleScroll();
  return (
    <Drawer anchor="right" open={open} onClose={closeDrawer}>
      <ResizableDrawer
        startWidth={width}
        minWidth={600}
        onSetWidth={onSetWidth}>
        <S.DrawerContents scrollWidth={scrolled.scrollHeight}>
          <LinkArtifactDrawerInner
            artifactTypeName={artifactTypeName}
            onClose={closeDrawer}
            defaultProjectName={defaultProjectName}
            afterLink={afterLink}
            artifact={artifact}
          />
        </S.DrawerContents>
      </ResizableDrawer>
    </Drawer>
  );
};
